import {
  firebaseFire as Libfirebase,
} from "../helpers/firebase-config.js";

import {
  firebaseAuth
} from '../helpers/firebase-config';

import axios from 'axios';
import md5 from 'md5';
import moment from 'moment';
import { getVeiculos } from "./Veiculos.js";
import { firebaseDb } from "../helpers/firebase-config2.js";
import { collection, getDocs, query, where } from "firebase/firestore";
import { PermissaoGeral } from "../helpers/enums.js";
const key = md5("globalKey" + (moment().format("YYYY-MM-DD-HH-MM")));

export function setUser(data) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection("usuario")
      .doc(data.CPF)
      .set(data)
      .then(async (_success) => {

        console.log('auth', data.email, data.senha);
        try {
          let fire = await firebaseAuth.createUserWithEmailAndPassword(data.email, data.senha);
          console.log('auth resukt', fire);
          if (!fire && data.email != '' && data.email.indexOf('@') > 4 && data.email.indexOf('.') > 10) {
            await firebaseAuth.createUserWithEmailAndPassword(data.email, data.senha || data.CPF.replace(".", "").substr(0, 6))
              .then(async (res) => {
                data.userUID = res.user.uid;
              }).catch(error => {
                data.userUID = null;
                if (error.code === "auth/email-already-in-use") {
                  //alert("Este e-mail já está em uso!");
                } else {

                }
              }
              );

          } else {
            data.userUID = fire.uid;
          }
        } catch (err) {

        }
        console.log('antes senha', data)
        if (!data.userUID) {
          try {
            axios.post('https://us-central1-globalbrain-ba498.cloudfunctions.net/pdf/changeUser', { email: data.email, senha: data.senha, key }).then(res => {
              console.log('senha alterada ok', res);
            })
            data.userUID = (await firebaseAuth.getUserByEmail(data.email)).uid;
          } catch (er) {
            console.log('error on getbyemail', er);
          }
        }
        if (data.userUID) {
          let a = await firebaseAuth.updateUser(data.userUID, { password: data.senha });
          console.log('senha alt', a)
        }

        resolve(true);

        //if(data.profissao === 'Motorista'){
        //}

      })
      .catch(error => reject(error));
  });
}

export async function updateEspecialidades() {

  var medicos = await Libfirebase.collection('usuario').get();

  for (let medico of medicos.docs) {
    var especialidadesList = [];

    if (medico.data().especialidade)
      especialidadesList.push(medico.data().especialidade);

    await medico.ref.update({
      especialidades: especialidadesList
    });


  }

}

// export function deleteUser(data) {
//   return new Promise(function(resolve, reject) {
//     Libfirebase.collection('usuario')
//       .doc(data.CPF)
//       .delete()
//       .then(success => {
//         resolve(true);
//       })
//       .catch(error => reject(error));
//   });
// }

export function deleteUser(id, data) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection("usuario")
      .doc(id)
      .update(data)
      .then(success => {
        resolve(true);
      })
      .catch(error => reject(error));
  });
}

export async function getUser(email) {

  console.log("userSnap.docs")
  // let userSnap = await Libfirebase.collection("usuario")
  //   .where("email", "==", email)
  //   .get()
  // let userSnap = await Libfirebase.collection("cidade")
  //   .where("Cidade", "==", "Franca")
  //   .get()

  // console.log("userSnap.docs", userSnap.docs)

  return new Promise(async function (resolve, reject) {
    Libfirebase.collection("usuario")
      .where("email", "==", email)
      .get()
      .then(async (snap) => {
        snap.forEach(async (doc) => {
          const data = {
            id: doc.id,
            usuario: doc.data()
          };
          if (doc.data().cidade) {
            await Libfirebase.doc("cidade/" + doc.data().cidade).get().then(res => {
              if (res.exists) {
                data.usuario.Cidade = res.data().Cidade;
              }
            });
          }

          resolve(data);
        });
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function saveLogEdit(data, cpf) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection("usuario")
      .doc(cpf)
      .collection('audit')
      .add(data)
      .then(success => {
        resolve(true);
      })
      .catch(error => reject(error));
  });
}

export function getUserId(id) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection("usuario")
      .doc(id)
      .get()
      .then(snap => {
        const data = {
          id: snap.id,
          usuario: snap.data()
        };
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function getUserEmail(email) {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection("usuario")
      .where('email', '==', email)
      .get()
      .then(docs => {
        if (docs.docs.length <= 0)
          resolve([])
        else {
          const data = {
            id: docs.docs[0].id,
            usuario: docs.docs[0].data()
          };
          resolve(data);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}

export async function getListUser(secretariaSelecionada, permissao) {
  // return new Promise(async function (resolve, reject) {
  // console.log("BUSCANDO USUARIOS----------", secretariaSelecionada);
  try {
    let cidades = ((await Libfirebase.collection("cidade").get())).docs.map((doc) => {
      return {
        ...doc.data(),
        id: doc.id
      }
    })

    let qr = Libfirebase.collection("usuario")
      .where('permissao', '!=', PermissaoGeral.Paciente);

    // if (ativo) {
    //   qr = qr.where('ativo', '==', true);
    // }
    console.log("tem secretaria aqui?", secretariaSelecionada)
    if (secretariaSelecionada && secretariaSelecionada.id) {
      qr = qr.where('secretaria', '==', secretariaSelecionada.id);
    }
    if (permissao && permissao.length > 0) {
      qr = qr.where('permissao', '==', permissao.toString());
    }

    let result = (
      await qr
        .get()).docs.filter(doc => doc.data().permissao && doc.data().permissao.toString() != '3').map(doc => {
          let cid = cidades.find(x => x.id === doc.data().cidade);
          return {
            ref: doc.ref,
            id: doc.id,
            user: doc.data(),
            cidade: cid ? cid.Cidade : '',
            especialidades: doc.data().especialidades
          };
        });
    // console.log("------------->11111111111111111111111111111111111111111", result)
    return result;
  } catch (err) {
    console.log("ERRRO AO BUCSAR USUARIOS--------->", err)
  }


  // .then(async (snapShot) => {
  //   let listUsuario = [];

  //   var final = snapShot.docs.length - 1;
  //   var count = 0;
  //   await snapShot.forEach(async (doc) => {
  //     let data = {
  //       ref: doc.ref,
  //       id: doc.id,
  //       user: doc.data(),
  //       cidade: '',
  //       especialidades: doc.data().especialidades
  //     };

  //     if (doc.data().cidade) {
  //       await Libfirebase.collection("cidade")
  //         .doc(doc.data().cidade)
  //         .get()
  //         .then(city => {
  //           if (city.exists) {
  //             data.cidade = (city.data().Cidade);
  //           }
  //         });
  //     }
  //     if (doc.data().permissao && doc.data().permissao.toString() != '3') {
  //       listUsuario.push(data);
  //     }
  //     // if (count >= final) {
  //     //   console.log(2222222222222222222222222222222222, listUsuario);
  //     //   resolve();
  //     // }
  //     count++;
  //   });
  // })
  // .catch(erro => reject(erro.code));
  // });
}

export async function getListMedicos() {
  return new Promise(async function (resolve, reject) {

    let listUsuario = [];

    await Libfirebase.collection("usuario")
      .where('ativo', '==', true)
      .get()
      .then(async (snapShot) => {
        var final = snapShot.docs.length - 1;
        var count = 0;
        snapShot.docs.forEach(async (doc) => {
          let data = {
            id: doc.id,
            user: doc.data(),
            cidade: '',
            ref: doc.ref
          };

          data.user.permissao = data.user.permissao.toString();

          if (doc.data().cidade) {
            await Libfirebase.collection("cidade")
              .doc(doc.data().cidade)
              .get()
              .then(city => {
                if (city.exists) {
                  data.cidade = (city.data().Cidade);
                }
              });
          }
          if (data.user.profissao === 'Medico' || data.user.profissao === 'Médico Geral' || data.user.profissao === 'Especialista')
            listUsuario.push(data);
          if (count >= final) {
            // listUsuario = listUsuario.filter(e => e.user.profissao === 'Medico' ||e.user.profissao === 'Médico Geral' || e.user.profissao === 'Especialista');
            resolve(listUsuario);
          }
          count++;
        });
      })
      .catch(erro => reject(erro.code));

    resolve(listUsuario);
  });
}

export async function getListMedicosNew() {
  const algoliasearch = require("algoliasearch");
  const client = algoliasearch("S4T1I4OXWN", "01bed30f13ef39976e5b4204eba41be4");
  const index = client.initIndex("usuario");

  return new Promise(async function (resolve, reject) {

    let listUsuario = [];
    // index.setFilters('profissao:"Médico Geral"')
    //   // index.search('', {
    //   //   // facets: ['profissao:Médico Geral']
    //   //   filters: 'profissao:"Médico Geral" AND profissao:"Especialista"'
    //   // })
    //   // .setSettings({
    //   //   attributesForFaceting: [
    //   //     'profissao',
    //   //     'searchable(Médico Geral)'
    //   //   ]
    //   // })
    //   .then(({ hits }) => {
    //     console.log(hits);


    //     hits.forEach((h) => {
    //       let data = {
    //         ref: Libfirebase.doc(h.path),
    //         id: h.objectID,
    //         paciente: h
    //       };

    //       listUsuario.push(data)
    //     })

    //     resolve(listUsuario);
    //   })
    //   .catch(err => {
    //     console.log(err);
    //     reject(err)
    //   });



    // console.log("getmedicos")
    const q = query(
      collection(firebaseDb, "usuario"),
      where("ativo", "==", true),
      where('profissao', 'in', ['Medico', 'Médico Geral', 'Especialista'])
    );

    await getDocs(q)
      .then(async (snapShot) => {
        snapShot.docs.forEach(async (doc) => {
          let data = {
            id: doc.id,
            user: doc.data(),
            cidade: '',
            ref: doc.ref
          };

          data.user.permissao = data.user.permissao.toString();
          listUsuario.push(data)
        });
      })
      .catch(erro => reject(erro.code));

    resolve(listUsuario);
  });
}

export async function getListMedicosAll() {

  return new Promise(async function (resolve, reject) {
    var auxMedicos = [];

    await Libfirebase.collection("usuario")
      .where('ativo', '==', true)
      // .where('permissao','<','3')
      .get().then(query => {
        query.docs.forEach(e => {
          var data = {
            label: e.data().nome,
            value: {
              user: e.data(),
              ref: e.ref,
              id: e.id
            }
          };


          if ((e.data().profissao === 'Médico Geral' || e.data().profissao === 'Medico' || e.data().profissao === 'Especialista' || e.data().profissao === 'Médico Especialista') && e.data().ativo === true)
            auxMedicos.push(data)
        });

      });

    resolve(auxMedicos)
  });

}

export function getListUserAtivos() {
  return new Promise(function (resolve, reject) {
    Libfirebase.collection("usuario")
      .get()
      .then(snapShot => {
        let listUsuario = [];

        var final = snapShot.docs.length - 1;
        var count = 0;
        snapShot.forEach(doc => {
          Libfirebase.collection("cidade")
            .doc(doc.data().cidade)
            .get()
            .then(city => {
              let data = {
                id: doc.id,
                user: doc.data(),
                cidade: city.data().Cidade
              };
              if (data.excluido === true) {
                listUsuario.push(data);
              }

              count++;
              if (final === count) {
                resolve(listUsuario);
              }
            });
        });
      })
      .catch(erro => reject(erro.code));
  });
}

export function getAllUsers() {
  return new Promise(async function (resolve, reject) {

    let listUsuario = [];

    await Libfirebase.collection("usuario")
      .where('ativo', '==', true)
      .get()
      .then(async (snapShot) => {
        var final = snapShot.docs.length - 1;
        var count = 0;
        snapShot.docs.forEach(async (doc) => {
          let data = {
            id: doc.id,
            user: doc.data(),
            cidade: '',
            ref: doc.ref
          };

          data.user.permissao = data.user.permissao.toString();

          if (doc.data().cidade) {
            await Libfirebase.collection("cidade")
              .doc(doc.data().cidade)
              .get()
              .then(city => {
                if (city.exists) {
                  data.cidade = (city.data().Cidade);
                }
              });
          }
          listUsuario.push(data);
          if (count >= final) {
            // listUsuario = listUsuario.filter(e => e.user.profissao === 'Medico' ||e.user.profissao === 'Médico Geral' || e.user.profissao === 'Especialista');
            resolve(listUsuario);
          }
          count++;
        });
      })
      .catch(erro => reject(erro.code));

    resolve(listUsuario);
  });
}

export function updateUser(id, data) {
  return new Promise(function (resolve, reject) {



    console.log('buscando user', data.email, key);
    axios.post('https://us-central1-globalbrain-ba498.cloudfunctions.net/pdf/changeUser', { email: data.email, senha: data.senha, key }).then(res => {
      console.log('senha alterada ok', res);
    })

    Libfirebase.collection("usuario")
      .doc(id)
      .update(data)
      .then(() => resolve(true))
      .catch(erro => reject(erro.code));

  });
}

export function getProfissional(ref) {
  return new Promise(function (resolve, reject) {
    ref
      .get()
      .then(doc => resolve(doc.data()))
      .catch(erro => reject(erro));
  });
}

export async function getMotoristas(secretaria) {

  let db = Libfirebase.collection("usuario")
    .where("permissao", "==", "6");

  if (secretaria && secretaria.id) {
    db = db.where('secretaria', '==', secretaria.id);
  }

  console.log(1);

  let ListaVeiculos = await getVeiculos(null, secretaria);

  let result = (await db.get()).docs.map(doc => {
    let docd = doc.data();
    let veiculoRef = ListaVeiculos.find(x => docd.veiculo ? docd.veiculo.id == x.id : false);
    return {
      id: doc.id,
      ref: doc.ref,
      motorista: doc.data(),
      veiculo: veiculoRef
    }
  });

  console.log('veics', result);

  return result;
  // return new Promise(async function (resolve, reject) {




  // resolve(result);


  // db.get()
  // .then(async snapShot => {
  //   let listUsuario = [];

  //   var final = snapShot.docs.length - 1;
  //   var count = 0;

  //   snapShot.docs.forEach(async doc => {
  //     let data = {
  //       id: doc.id,
  //       ref: doc.ref,
  //       motorista: doc.data(),
  //       veiculo: ""
  //     };


  //     if (doc.data().veiculo.id) {
  //       await Libfirebase.collection("veiculos")
  //         .doc(doc.data().veiculo.id)
  //         .get()
  //         .then(car => {
  //           if (car.exists) {
  //             data.veiculo = car.data();
  //           }
  //         });
  //     }

  //     listUsuario.push(data);

  //     if (final === count) {
  //       resolve(listUsuario);
  //     }
  //     count++;
  //   })
  // })
  // .catch(erro => reject(erro.code));
  // });
}

export function getPacientes() {
  return new Promise(async function (resolve, reject) {

    let listUsuario = [];

    await Libfirebase.collection("usuario")
      .where('ativo', '==', true)
      .where('profissao', '==', 'Paciente')
      .get()
      .then(async (snapShot) => {
        var final = snapShot.docs.length - 1;
        var count = 0;
        snapShot.docs.forEach(async (doc) => {
          let data = {
            id: doc.id,
            user: doc.data(),
            ref: doc.ref
          };

          listUsuario.push(data);
          if (count >= final) {
            resolve(listUsuario);
          }
          count++;
        });
      })
      .catch(erro => reject(erro.code));

    resolve(listUsuario);
  });
}

export function getUserByPath(path) {
  return new Promise(function (resolve, reject) {
    return Libfirebase.doc(path)
      .get()
      .then(snapShot => {
        resolve({
          id: snapShot.id,
          ref: snapShot.ref,
          ...snapShot.data()
        })
      })
      .catch(erro => reject(erro.code));
  });
}